import { createTheme } from '@material-ui/core/styles'
import { colors } from 'utils/colors'

export const lightTheme = createTheme({
  palette: {
    type: 'light',
    background: {
      default: '#fff'
    },
    primary: {
      main: colors.indigo,
      contrastText: '#fff'
    },
    secondary: {
      main: colors.indigo
    }
  },
  typography: {
    fontSize: 14,
    fontFamily: 'Roboto',
    fontWeightRegular: 400,
    button: {
      textTransform: 'none',
      fontWeight: 400,
      letterSpacing: '0.3px'
    }
  },
  shape: {
    borderRadius: '0.5rem'
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 400,
      md: 700,
      lg: 1100,
      xl: 1500,
      xxl: 1800
    }
  }
})
